
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Localized_Prostate_Cancer_Risk_Grading",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Localized_Prostate_Cancer_Risk_Grading.vue